/**
 * Path to a legacy Proposal's "no longer available" page.
 *
 * The id is carried so the URL names the Proposal, but the page ignores it —
 * callers hold either the numeric job id or the publicId, and neither is
 * looked up. The Project is optional because the page still explains itself
 * without one, it just cannot link on to the Project's files.
 */
export const legacyProposalPath = (
  proposalId: number | string,
  projectPublicId?: string
): string =>
  projectPublicId
    ? `/proposals/${proposalId}?projectId=${projectPublicId}`
    : `/proposals/${proposalId}`;
